import Auth from '@js/plugins/auth';

export default {
    computed: {
        canAccessAllOutlets() {
            return Auth.canAccessAllOutlets();
        },

        firstAvailableOutlet() {
            if (this.canAccessAllOutlets) {
                return 0;
            }

            return _.first(Auth.outlets());
        },
    },

    methods: {
        hasAnyPermission(...permission) {
            return Auth.hasAnyPermission(permission);
        },

        hasPermissionTo(permission) {
            return Auth.hasPermissionTo(permission);
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/auth.js